/* AI SUMMARY OF A REPORT PAGE (2026-10-24) — the Sales Report's Weekly / Monthly page and a Data Explorer page. */
const en = {
  title: 'AI summary',
  open: 'Summarise this page',
  hint: 'Highlights, lowlights and where to dig next — written by Claude from the figures on this page.',
  writing: 'Reading the figures and writing…',
  highlights: 'Highlights',
  lowlights: 'Lowlights',
  dig: 'Dig deeper',
  rewrite: 'Write again',
  hide: 'Hide',
  note: 'Written by Claude from this page\'s figures (code works the figures out; the AI only words them). Check a figure on the page before quoting it.',
  written: 'Written {{time}}',
  fromCache: 'kept from {{time}} — the figures have not changed since',
  unavailable: 'The AI cannot answer right now: {{reason}}',
  failed: 'The summary could not be written: {{reason}}',
  onlyWeeklyMonthly: 'The AI summary reads the Weekly and Monthly pages.',
  nothingYet: 'Open a report first.',
  stale: 'The page changed — the summary is being written again.',
};
const ko = {
  title: 'AI 요약',
  open: '이 페이지 요약',
  hint: '하이라이트, 로우라이트, 더 살펴볼 부분 — 이 페이지의 수치로 Claude가 작성합니다.',
  writing: '수치를 읽고 작성하는 중…',
  highlights: '하이라이트',
  lowlights: '로우라이트',
  dig: '더 살펴보기',
  rewrite: '다시 작성',
  hide: '숨기기',
  note: '이 페이지의 수치로 Claude가 작성했습니다 (수치는 코드가 계산하고 AI는 문장만 씁니다). 인용하기 전에 페이지의 수치를 확인하세요.',
  written: '{{time}} 작성',
  fromCache: '{{time}} 작성분 — 이후 수치 변동 없음',
  unavailable: '지금은 AI가 답할 수 없습니다: {{reason}}',
  failed: '요약을 작성하지 못했습니다: {{reason}}',
  onlyWeeklyMonthly: 'AI 요약은 Weekly와 Monthly 페이지를 읽습니다.',
  nothingYet: '먼저 보고서를 여세요.',
  stale: '페이지가 바뀌어 요약을 다시 작성하는 중입니다.',
};
const vi = {
  title: 'Tóm tắt AI',
  open: 'Tóm tắt trang này',
  hint: 'Điểm sáng, điểm tối và hướng đào sâu — Claude viết từ số liệu trên trang này.',
  writing: 'Đang đọc số liệu và viết…',
  highlights: 'Điểm sáng',
  lowlights: 'Điểm tối',
  dig: 'Đào sâu thêm',
  rewrite: 'Viết lại',
  hide: 'Ẩn',
  note: 'Claude viết từ số liệu của trang này (code tính số, AI chỉ diễn đạt). Kiểm tra lại số trên trang trước khi trích dẫn.',
  written: 'Viết lúc {{time}}',
  fromCache: 'bản viết lúc {{time}} — số liệu chưa đổi từ đó',
  unavailable: 'AI hiện không trả lời được: {{reason}}',
  failed: 'Không viết được tóm tắt: {{reason}}',
  onlyWeeklyMonthly: 'Tóm tắt AI đọc trang Weekly và Monthly.',
  nothingYet: 'Hãy mở một báo cáo trước.',
  stale: 'Trang đã thay đổi — đang viết lại tóm tắt.',
};
const zh = {
  title: 'AI 摘要',
  open: '总结本页',
  hint: '亮点、不足和深入方向 — 由 Claude 根据本页数据撰写。',
  writing: '正在读取数据并撰写…',
  highlights: '亮点',
  lowlights: '不足',
  dig: '深入分析',
  rewrite: '重新撰写',
  hide: '隐藏',
  note: '由 Claude 根据本页数据撰写（数字由代码计算，AI 只负责措辞）。引用前请核对页面上的数字。',
  written: '撰写于 {{time}}',
  fromCache: '{{time}} 的版本 — 此后数据未变',
  unavailable: 'AI 暂时无法回答：{{reason}}',
  failed: '无法撰写摘要：{{reason}}',
  onlyWeeklyMonthly: 'AI 摘要读取 Weekly 和 Monthly 页面。',
  nothingYet: '请先打开报告。',
  stale: '页面已变化 — 正在重新撰写摘要。',
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "title": "Synthèse IA",
  "open": "Résumer cette page",
  "hint": "Points forts, points faibles et pistes à creuser — rédigés par Claude à partir des chiffres de cette page.",
  "writing": "Lecture des chiffres et rédaction…",
  "highlights": "Points forts",
  "lowlights": "Points faibles",
  "dig": "Approfondir",
  "rewrite": "Rédiger à nouveau",
  "hide": "Masquer",
  "note": "Rédigé par Claude à partir des chiffres de cette page (le code calcule les chiffres ; l’IA se contente de les formuler). Vérifiez un chiffre sur la page avant de le citer.",
  "written": "Rédigé {{time}}",
  "fromCache": "conservé depuis {{time}} — les chiffres n’ont pas changé depuis",
  "unavailable": "L’IA ne peut pas répondre pour le moment : {{reason}}",
  "failed": "La synthèse n’a pas pu être rédigée : {{reason}}",
  "onlyWeeklyMonthly": "La synthèse IA lit les pages Hebdomadaire et Mensuel.",
  "nothingYet": "Ouvrez d’abord un rapport.",
  "stale": "La page a changé — la synthèse est en cours de réécriture."
};
const ja = {
  "title": "AI要約",
  "open": "このページを要約",
  "hint": "ハイライト、ローライト、次に掘り下げる点を、このページの数値をもとにClaudeが作成します。",
  "writing": "数値を読み込んで作成しています…",
  "highlights": "ハイライト",
  "lowlights": "ローライト",
  "dig": "さらに掘り下げる",
  "rewrite": "再作成",
  "hide": "非表示",
  "note": "このページの数値をもとにClaudeが作成しました（数値の算出はコードが行い、AIは文章化するだけです）。引用する前に、ページ上の数値を確認してください。",
  "written": "{{time}}に作成",
  "fromCache": "{{time}}の内容を保持 — それ以降、数値に変更はありません",
  "unavailable": "現在、AIは回答できません：{{reason}}",
  "failed": "要約を作成できませんでした：{{reason}}",
  "onlyWeeklyMonthly": "AI要約は、週次ページと月次ページが対象です。",
  "nothingYet": "先にレポートを開いてください。",
  "stale": "ページが変更されたため、要約を再作成しています。"
};

export default { ns: 'xInsight', en, ko, vi, zh, fr, ja };
